// Delegate to the focused form so browser validation and normal submit guards apply.
// A page-level handler covers questions, edits, polls and access forms equally.
export function submitFormOnShortcut(event) {
  if (event.defaultPrevented || event.key !== 'Enter' || !(event.ctrlKey || event.metaKey) || event.altKey || event.isComposing || event.keyCode === 229) return
  const form = event.target?.closest?.('form')
  if (!form || typeof form.requestSubmit !== 'function') return
  event.preventDefault()
  if (event.repeat) return
  const submitters = [...form.querySelectorAll('button:not([type]), button[type="submit"], input[type="submit"], input[type="image"]')]
    .filter(element => element.form === form)
  const submitter = submitters.find(element => !element.disabled && !element.matches(':disabled') && !element.hidden && element.getAttribute('aria-disabled') !== 'true')
  if (!submitter || form.getAttribute('aria-busy') === 'true') return
  form.requestSubmit(submitter)
}
